import { defineKey as T } from 'ha/i18n';

export const ERROR_MESSAGES = {
  412: T(
    'You cannot take this action right now. Refreshing the page might resolve the issue, if not please reach out to us.',
  ),
  417: T('Payment failed'),
  422: T('Payment method creation failed'),
  400: T('Please propose different dates or a different price'),
  startDate: T(
    'The selected dates are not available according to your calendar. Please check the availability and your minimum rental period',
  ),
  DEFAULT: T('Something went wrong'),
};
